module.exports = __webpack_public_path__ + "img/ball_8_green.b87189dd.png";